import { CountUp } from 'countup.js';

const countUpStats = document.querySelectorAll('.block-stat [data-number]');

if (countUpStats.length > 0) {
	const scrollObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const { target } = entry;
				const number = target?.getAttribute('data-number') ?? null;
				const hasAnimated =
					target?.getAttribute('data-has-animated') === 'true';

				if (number && !hasAnimated) {
					const countup = new CountUp(target, number, {
						duration: 3,
					});
					countup.start();
					target?.setAttribute('data-has-animated', 'true');
				}
			});
		},
		{
			root: null,
			rootMargin: '0px',
			scrollMargin: '0px',
			threshold: 1.0,
		}
	);

	countUpStats.forEach((stat) => {
		scrollObserver.observe(stat);
	});
}
